<template>
  <f7-page name="group-marketplace">
    <f7-navbar :title="$t('marketplace.title')" back-link>
      <f7-nav-right v-if="view?.isAdmin">
        <f7-link @click="manage">
          <f7-icon f7="checklist" size="18" />
        </f7-link>
        <f7-link @click="view?.openSettings()">
          <f7-icon f7="gear_alt" size="18" />
        </f7-link>
      </f7-nav-right>
    </f7-navbar>
<AppLayout>
      <template #main>
    <MarketplaceView ref="view" :group-id="groupId" />
      </template>
    </AppLayout>
  </f7-page>
</template>

<script setup>
import { ref } from "vue";
import { f7 } from "framework7-vue";
import MarketplaceView from "../components/marketplace/MarketplaceView.vue";
import AppLayout from "../components/common/AppLayout.vue";

const props = defineProps({ groupId: { type: String, required: true } });

const view = ref(null);

function manage() {
  f7.views.main.router.navigate(`/groups/${props.groupId}/marketplace/admin`);
}
</script>
